import type { JsonType } from "posthog-js";
import { useFeatureFlagEnabled, useFeatureFlagPayload } from "posthog-js/react";
import type postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import { envMode } from "@ch/api";

export interface TProps {
  featureFlagName: (typeof postHogFeatureFlagKeys)[keyof typeof postHogFeatureFlagKeys];
  skipOnDev?: boolean;
}
interface TReturn<T> {
  isFeatureFlagEnabled: boolean;
  payload: T;
  skipOnDev: boolean;
}

function usePostHogFeatureFlag<T = JsonType>({
  featureFlagName,
  skipOnDev = false,
}: TProps): TReturn<T> {
  const isFeatureFlagEnabled = useFeatureFlagEnabled(featureFlagName);
  const payload = useFeatureFlagPayload(featureFlagName);

  return {
    isFeatureFlagEnabled:
      skipOnDev && envMode === "development"
        ? false
        : Boolean(isFeatureFlagEnabled),
    payload: payload as T,
    skipOnDev: skipOnDev && envMode === "development",
  };
}

export default usePostHogFeatureFlag;
